import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';


//*MUI
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { makeStyles } from '@mui/styles';

//*Services
import Sidebar from '../../Components/Sidebar/Sidebar';

const useStyles = makeStyles((theme) => ({
    outletContainer: { 
        width : "calc(100% - 2.4rem)", 
          backgroundColor:'#F9FAFB'   
    }
}));

export default function MainPage() {
    const classList = useStyles();

    const drawerWidth = 260;
    const container = window !== undefined ? () => window.document.body : undefined;
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
      };

    return (
        <Box sx={{ display: 'flex' }} height={"100%"}>
        <Box
            sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
            aria-label="mailbox folders"
        >
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
                display: { xs: 'block', sm: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
            >
            <Sidebar />
            </Drawer>
            <Drawer
            variant="permanent"
            sx={{
                display: { xs: 'none', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
            open
            >
            <Sidebar />
            </Drawer>
        </Box>
        <Box className={classList.outletContainer} display={"flex"} flexDirection={"column"} sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)`} }}>
            <Box sx={{ flexGrow: 1  ,   backgroundColor:'#F9FAFB'}}>
                <Outlet />
            </Box>
            
        </Box>
        </Box>
    )
}
